import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import queryString from 'query-string'; //for skipping nulls and empty string values

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_REPORT_PORT,
    prepareHeaders: (headers) => {
      // const token = localStorage.getItem('token');
      // console.log('PREPARE HEADERS — token:', token);
      headers.set('Accept', 'application/json');
      headers.set('Authorization', `Bearer ${localStorage.getItem('token')}`);
      headers.set('X-Auth-Token', `Bearer ${localStorage.getItem('token')}`);

      return headers;
    },

    paramsSerializer: (params) => {
      return queryString.stringify(params, {
        skipNull: true,
        skipEmptyString: true,
      });
    },
  }),
  endpoints: () => ({}),
});
